// extracted by mini-css-extract-plugin
export default {"lang-ordinary":"lang_lang-ordinary__M464L","lang-image":"lang_lang-image__csarq","lang-choose":"lang_lang-choose__rX+eH","lang-items":"lang_lang-items__60A55"};